import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import PropTypes from 'prop-types';
import SelectBase from './SelectBase';

export const SelectRemoteBase = (props) => {
   const [isLoading, setIsLoading] = useState(true);
   const [options, setOptions] = useState([]);

   useEffect(() => {
      if (lodash.isFunction(props.getSuggestions)) {
         const promiseGetOptions = props.getSuggestions(props.suggestionDependencies);
         if (promiseGetOptions instanceof Promise) {
            promiseGetOptions.then(({ data }) => {
               const optionsToSave = props.handleApiDataResponse != null
                  ? props.handleApiDataResponse(data)
                  : data;
               setOptions(optionsToSave);
               setIsLoading(false);
            }).catch((error) => {
               // a rejected fetch (e.g. 403) previously left the select in its
               // loading state forever — fail into an empty, non-loading select
               console.error('remote select options failed to load:', error);
               setOptions([]);
               setIsLoading(false);
            });
         } else {
            console.error('Get options argument must be a promise.');
            setIsLoading(false);
         }
      } else {
         console.error('remoteOptionSelectFactory requires argument promiseGetOptions to be a function that returns a Promise object.');
         setIsLoading(false);
      }
   }, [JSON.stringify(props.suggestionDependencies), props.numberChangeToRefresh]);

   return (
      <SelectBase
         {...props}
         isLoading={isLoading}
         options={options}
      />
   );
};

SelectRemoteBase.propTypes = {
   getSuggestions: PropTypes.func.isRequired,
   handleApiDataResponse: PropTypes.func,

   suggestionDependencies: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.number]),
   numberChangeToRefresh: PropTypes.number,
};

SelectRemoteBase.defaultProps = {
   handleApiDataResponse: null,
   suggestionDependencies: undefined,
   numberChangeToRefresh: undefined,
};

// getOptions: Promise where onSuccess the argument is the options....
// Fetches the options from the promise
const remoteOptionSelectFactory = ({
   getSuggestionsPromise,
   handleApiDataResponse = null,
}) => {
   const OuterRemoteOptionSelectFactory = (props) => {
      return (
         <SelectRemoteBase
            {...props}
            getSuggestions={getSuggestionsPromise}
            handleApiDataResponse={handleApiDataResponse}
         />
      );
   };

   return OuterRemoteOptionSelectFactory;
};

export default remoteOptionSelectFactory;
